import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert, InputGroup } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import '../auth/Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [message, setMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            // This call must throw if the backend sends 401
            await login({ username, password, rememberMe });
            setMessage('Login successful');
            setTimeout(() => {
                navigate('/home');
            }, 1000);
        } catch (error) {
            const errorMessage =
                error.response?.data?.message ||
                error.response?.data || // If the server sends text, not JSON
                'Login failed: Incorrect username or password';
            setMessage(errorMessage);
        }
    };

    return (
        <div className="login-wrapper">
            <Container className="login-card">
                <Container className="mt-5" style={{ maxWidth: '400px' }}>
                    <Row className="justify-content-center">
                        <Col>
                            <h1 className="text-center mb-4">Sign In</h1>
                            <Form onSubmit={handleLogin}>
                                <Form.Group className="mb-3" controlId="username">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter username"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="password">
                                    <Form.Label>Password</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type={showPassword ? 'text' : 'password'}
                                            placeholder="Enter password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => setShowPassword(!showPassword)}
                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </Button>
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="remember">
                                    <Form.Check
                                        type="checkbox"
                                        label="Remember me"
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                    />
                                </Form.Group>

                                <Button variant="primary" type="submit" className="w-100">
                                    Sign In
                                </Button>
                            </Form>

                            {message && (
                                <Alert
                                    variant={message === 'Login successful' ? 'success' : 'danger'}
                                    className="mt-3 text-center"
                                >
                                    {message}
                                </Alert>
                            )}

                            <Row className="mt-3">
                                <Col xs="6">
                                    <Link to="/forgot-password" className="text-muted">
                                        Forgot password?
                                    </Link>
                                </Col>
                                <Col xs="6" className="text-end">
                                    <Link to="/register" className="text-muted">
                                        Don't have an account? Sign Up
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    );
};

export default Login;